export function isURL(url: string) {
    const pattern = /^(https:\/\/)?(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}|localhost)(:\d{1,5})?(\/[^\s]*)?$/i;

    return !!pattern.test(url);
}
